module.exports = __webpack_public_path__ + "static/media/Cats Eyes 10_ENGELSKA-mixdown.1c6ee1e8.mp3";